import moment from 'moment';
import React, { useContext, useMemo } from 'react';
import { useField } from 'react-final-form';
import styled from 'styled-components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { Flex, TimeField } from '@ubeya/shared-web/components';
import { totalDuration } from 'scheduling/utils';

const TimeFieldsWrapper = styled(Flex)`
  gap: 16px;
`;

const StartTimeField = styled(TimeField)`
  [disabled] {
    border-color: ${({ theme }) => theme.colors.grey1};
    background-color: ${({ theme }) => theme.colors.grey1};
    color: ${({ theme }) => theme.colors.grey3};
    :hover {
      border-color: transparent;
    }
  }
`;

const EndTimeField = styled(TimeField)``;

const TotalTime = styled.div`
  white-space: nowrap;
`;

const EndTimeTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 4px;
`;

const HourlyBookingGeneralTimeFields = ({
  startTimeFieldName,
  showLabelField,
  defaultStartValue,
  defaultEndValue,
  startPlaceholder,
  endPlaceholder,
  endTimeFieldName,
  timePickerOptions,
  showInFirstRow,
  interval,
  validate,
  hasTotalTime,
  readOnly = false
}) => {
  const { t, hourFormat } = useContext(ConfigContext);

  const {
    input: { value: startTimeValue }
  } = useField(startTimeFieldName);

  const {
    input: { value: endTimeValue }
  } = useField(endTimeFieldName);

  const totalShiftHours = useMemo(
    () => moment.utc(totalDuration(startTimeValue, endTimeValue).asMilliseconds()).format('HH:mm'),
    [endTimeValue, startTimeValue]
  );

  const endTimeStartOptionsValue = moment(startTimeValue).add(30, 'minutes');

  return (
    <TimeFieldsWrapper>
      <StartTimeField
        $showLabelField={showLabelField}
        title={t('start')}
        name={startTimeFieldName}
        $hourFormat={hourFormat}
        usePortal
        defaultOptions={timePickerOptions}
        validate={validate}
        defaultValue={defaultStartValue}
        interval={interval}
        placeholder={startPlaceholder}
        $showInFirstRow={showInFirstRow}
        isDisabled={readOnly}
      />

      <EndTimeField
        $showLabelField={showLabelField}
        title={
          <EndTimeTitleWrapper>
            <div>{t('end')}</div>
            <TotalTime>{`(${totalShiftHours}${t('h')})`}</TotalTime>
          </EndTimeTitleWrapper>
        }
        name={endTimeFieldName}
        usePortal
        defaultValue={defaultEndValue || endTimeStartOptionsValue}
        validate={validate}
        $hourFormat={hourFormat}
        visible={false}
        defaultOptions={timePickerOptions}
        interval={interval}
        $showInFirstRow={showInFirstRow}
        placeholder={endPlaceholder}
        hasTotalTime={hasTotalTime || !!totalShiftHours}
        isDisabled={readOnly}
      />
    </TimeFieldsWrapper>
  );
};

export default React.memo(HourlyBookingGeneralTimeFields);
